<body class="home-page01 container-fluid p528">
  <div class="content">
    <div class="main">
      <div class="container-fluid full-width">
        <div class="top-cont">
          <div class="business-services__container_pay">
            <div class="div-bus cus-bnd">

              <span>
                <h3 class="product-disc bnd-0">UPS Capital<sup class="sup-title-class">®</sup> Privacy
                  Notice
                </h3><br>
                <hr class="hr_bus">
              </span>
              <div class="bus_wor0 privacy-c0">Effective Date: June 03, 2026</div>

            </div>

          </div>
          <img class="vector-01" alt="background-arc" src="../../../../assets/redesignImages/Vector.png">

        </div>

        <div class=" up-1">
          <p>
            UPS Capital Corporation, its subsidiaries, UPS Capital Versicherungsvermittlung GmbH, its branches, UPS
            Capital Insurance Agency Limited, and UPSC (Thailand) Ltd. (each, a “UPS Capital Company” and collectively,
            the “UPS Capital Companies”) are affiliates of UPS. The UPS Capital Companies observe the <a
              href="http://www.ups.com/content/us/en/resources/ship/terms/privacy.html" rel="noopener"
              target="_blank" class="link">UPS Privacy Notice</a>, except as follows:
          </p>
          <br/>

          <p>(a) the first paragraph of the section entitled “Information We Obtain” shall be modified to read as
            follows: “We may obtain consumer personal information (such as name, contact details and payment
            information) in connection with various activities such as (i) use of the UPS websites and applications,
            (ii) shipping activities, including delivery and pick-up of shipments, (iii) requests to track shipments or
            answer questions, (iv) events in which we participate, (v) promotions and other offers, (vi) calls placed
            with customer service and accounting centers which may be recorded, and (vii) providing shipper’s agent,
            claims administration, claims adjustment, financial, insurance, shipping-related loss detection and
            prevention, and related services, as applicable.”;</p>
            <br/>
          <p> (b) The tenth bullet of the section entitled “Information We Obtain” shall be modified to read as follows:
            “Payment, financing and insurance information (including payment card details or online payment services
            number and invoicing address) and financial information (such as bank account numbers, personal financial
            statements, tax returns and credit reports)”;

          </p><br/>
          <p> (c) the second bullet point of the section entitled “How We Use The Information We Obtain” shall be
            modified to read as follows: “Provide products and services you request (such as logistics, supply chain
            management, customs clearance and brokerage services, and shipper’s agent, claims administration, claims
            adjustment, financial, insurance, shipping-related loss detection and prevention, and related services, as
            applicable)”;

          </p><br/>
          <p> (d) the second paragraph of the section entitled “Information We Share” shall be modified to read as
            follows: “We also may share the personal information we obtain with (i) our affiliates, franchisees,
            resellers, and joint marketing partners; (ii) shippers that obtain our shipper’s agent, claims
            administration, claims adjustment, financial, insurance, shipping-related loss detection and prevention, and
            related services; and (iii) claims administrators, claims adjusters, credit reporting agencies, insurers,
            guarantors, credit enhancement providers (including sureties, indemnitors, and export credit agencies) and
            their respective agents with which we do business. These entities, which collectively are referred to here
            as the “UPS Business Partners,” may use the information for the purposes described in this Privacy Notice.
            In addition, we may share physical location data with our UPS Business Partners and other third parties to,
            for example, enhance location-based services and develop accurate and up-to-date maps. In addition, except
            as described below, we may share other personal information with third parties who are not UPS Business
            Partners for those parties’ own purposes, such as to offer products or services that may interest you.”; and
          </p>
          <br/>
          <p>(e) We observe the “<a href="https://www.ups.com/us/en/support/shipping-support/legal-terms-conditions/privacy-notice#link14" target="_blank" rel="noopener" class="link">UPS: Privacy Notice - United States Addendum</a>” within the UPS Privacy Notice, except as follows:
          </p><br/>
          <p> (i) the first sentence of the section entitled “Disclosures of Personal Information for Monetary or Other
            Valuable Consideration or for Business Purposes” shall be modified to read as follows: “We “sell” and have
            “sold” identifiers within the twelve (12) months preceding the effective date of the <a class="link" href="https://www.ups.com/us/en/support/shipping-support/legal-terms-conditions/privacy-notice" target="_blank">UPS Privacy Notice </a> to
            third parties who obtain our shipping-related loss detection and prevention or related services.”;

          </p><br/>
          <p> (ii) the first two sentences of the “Right to Opt-Out” bullet in the section entitled “Your Privacy Rights”
            shall be modified to read as follows: “Right to Opt-Out: You have the right to submit a request to opt out
            of the “sale” of personal information about you and/or the “sharing” of personal information about you for
            cross-context behavioral advertising or targeted advertising. UPS Capital will honor such opt outs to the
            extent required by law. To submit an opt-out request, click <a class="link" href="/opt-out"> https://www.upscapital.com/opt-out </a>or as
            provided below under “Requests to Exercise Your Rights.””; and

          </p><br/>
          <p> (iii) the first sentence of the section entitled “Metrics Regarding Privacy Requests (California)” and the
            subsequent chart shall be modified to read as follows: “Please see the chart below for metrics relating to
            UPS Capital Corporation’s handling of California rights requests in the period from January 1, 2025, to
            December 31, 2025.</p>
          <br />
          <table>
            <tr>
              <th>Type of Request</th>
              <th>Number of Requests Received</th>
              <th>Number of Requests Complied With (In Whole or In Part)</th>
              <th>Number of Requests Denied</th>
              <th>Mean Days to Substantive Response</th>
              <th>Median Days to Substantive Response</th>
            </tr>
            <tr>
              <td>Requests to Delete</td>
              <td>0</td>
              <td>0</td>
              <td>0</td>
              <td>0</td>
              <td>0</td>
            </tr>
            <tr>
              <td>Requests to Know</td>
              <td>0</td>
              <td>0</td>
              <td>0</td>
              <td>0</td>
              <td>0</td>
            </tr>
            <tr>
              <td>Requests to Correct</td>
              <td>0</td>
              <td>0</td>
              <td>0</td>
              <td>0</td>
              <td>0</td>
            </tr>
            <tr>
              <td>Requests to Opt-Out</td>
              <td>17</td>
              <td>17</td>
              <td>0</td>
              <td>5.35</td>
              <td>5</td>
            </tr>
          </table>
          <br />
          <p>Where we maintain or use de-identified information, we will continue to maintain and use the de-identified
            information only in a de-identified fashion and will not attempt to re-identify the information, except as
            permitted under applicable law.</p>
        </div>

      </div>


    </div>
  </div>

</body>